// extracted by mini-css-extract-plugin
export var alwaysBig = "logo-module--alwaysBig--5542b";
export var logo = "logo-module--logo--e9167";
export var logoMobile = "logo-module--logoMobile--5f7f3";
export var logoWrap = "logo-module--logoWrap--3835e";
export var logoWrapMobile = "logo-module--logoWrapMobile--ce1a8";